/* eslint-disable @typescript-eslint/no-empty-object-type,@typescript-eslint/no-explicit-any */
/*
    Code shared by various mixins
*/
export const _asyncFSKeys = [
    'rename',
    'stat',
    'touch',
    'createFile',
    'unlink',
    'rmdir',
    'mkdir',
    'readdir',
    'exists',
    'link',
    'sync',
    'read',
    'write',
];
